/**
 * Where a QC comment points in the extraction a curator has open (DCTL-2746).
 *
 * `context.dataPointUuids` lists every point a comment covers, from both QC
 * inputs, Input A's first, so a link built from its first uuid sent Input B's
 * curator to a point that is not in their extraction. A comment now names each
 * addressed extraction's own points (`context.dataPointUuidsBySde`); an older
 * one is narrowed to the points the open extraction has (`owns`), or left
 * whole when the editor cannot tell.
 */

export const FIGURE_COMMENT_TARGET_TYPE = "figure";

/** The open extraction's own data point uuids for a comment, in order. */
export function ownDataPointUuids(context, sdeUuid, owns = null) {
	const own = context?.dataPointUuidsBySde?.[sdeUuid];
	if (Array.isArray(own)) return own;
	const all = context?.dataPointUuids || [];
	return typeof owns === "function" ? all.filter((uuid) => owns(uuid)) : all;
}

/** A figure comment's scope (points, series or figure), else null. */
export function figureCommentScope(comment) {
	if (comment?.targetType !== FIGURE_COMMENT_TARGET_TYPE) return null;
	return comment.context?.scope || null;
}

/**
 * The top-level comment a deep link's `commentUuid` names: the comment
 * itself, or the one a reply belongs to.
 */
export function commentForUuid(comments, uuid) {
	if (!uuid) return null;
	return (
		(comments || []).find(
			(comment) =>
				comment.uuid === uuid ||
				(comment.replies || []).some((reply) => reply.uuid === uuid),
		) || null
	);
}
